module.exports = __webpack_public_path__ + "img/04.5861a191.jpg";